import { Image, Text, View } from '@react-pdf/renderer'
import PDFCell from '@/components/ReportPDF/PDFCell'
import PDFPage from '@/components/ReportPDF/PDFPage'
import PDFRow from '@/components/ReportPDF/PDFRow'
import PDFTitle from '@/components/ReportPDF/PDFTitle'
import PDFParagraph from '@/components/ReportPDF/PDFParagraph'

const ReportRow = ({ group }) => {
  const { groupId, groupName, phishCount, report } = group
  const { userCount, openCount, linkCount, fileCount, textCount } = report

  return (
    <PDFRow width={1075} marginLeft={-85}>
      <PDFCell flex={0.5} style={{ backgroundColor: '#e8ecf2' }}>
        <Text>{groupId}</Text>
      </PDFCell>
      <PDFCell flex={4} style={{ backgroundColor: '#e8ecf2' }}>
        <Text>{groupName}</Text>
      </PDFCell>
      <PDFCell flex={1} style={{ backgroundColor: '#e8ecf2' }}>
        <Text>{userCount}</Text>
      </PDFCell>
      <PDFCell flex={1} style={{ backgroundColor: '#e8ecf2' }}>
        <Text>{phishCount}</Text>
      </PDFCell>
      <PDFCell flex={1} style={{ backgroundColor: '#e8ecf2' }}>
        <Text>{openCount}</Text>
      </PDFCell>
      <PDFCell flex={1} style={{ backgroundColor: '#e8ecf2' }}>
        <Text>{linkCount}</Text>
      </PDFCell>
      <PDFCell flex={1} style={{ backgroundColor: '#e8ecf2' }}>
        <Text>{fileCount}</Text>
      </PDFCell>
      <PDFCell flex={1} style={{ backgroundColor: '#e8ecf2' }}>
        <Text>{textCount}</Text>
      </PDFCell>
    </PDFRow>
  )
}

const Chapter4Sub4Page = ({ chartImg4, reportData, setPage }) => {
  const { deptReportGroups } = reportData || {}
  const count = deptReportGroups.filter(item => item.havePhish === true).length

  return (
    <>
      <PDFPage hideTitleDivider reportData={reportData}>
        <PDFTitle hideDivider>4.3 部門結果統計報表</PDFTitle>
        <Text
          render={({ pageNumber }) => {
            setPage({ chap4_3: pageNumber })
          }}
        />

        <View>
          <PDFParagraph>
            {'\u3000\u3000'}本次演練僅有
            <Text>{count}</Text>
            個部門同仁被釣中，依照
            <Text style={{ fontWeight: 'bold', fontSize: 20 }}>各部門參與演練與被釣中人數</Text>
            進行統計，統計圖表如下顯示:
            {count > 10 && <Text>(此圖表僅列出前十名的部門資訊 )</Text>}
          </PDFParagraph>
          {chartImg4 && <Image src={chartImg4} />}
        </View>
      </PDFPage>

      <PDFPage hideTitleDivider reportData={reportData}>
        <PDFTitle hideDivider fontSize={36}>
          4.3.1部門統計結果清單
        </PDFTitle>
        <Text
          render={({ pageNumber }) => {
            setPage({ chap4_3_1: pageNumber })
          }}
        />

        <View>
          <PDFParagraph>
            {'\u3000\u3000'}依照
            <Text>各部門受測人數</Text>
            ，統計出
            <Text>各部門之受測者</Text>
            <Text>「瀏覽郵件」、「點閱連結」、「開啟附件」與「輸入資料」</Text>
            等之人數。
          </PDFParagraph>
          <PDFRow style={{ fontWeight: 'bold' }} width={1075} marginLeft={-85}>
            <PDFCell
              flex={0.5}
              style={{
                backgroundColor: `#4c82bf`,
              }}
            >
              <Text style={{ color: 'white' }}>排名</Text>
            </PDFCell>
            <PDFCell
              flex={4}
              style={{
                backgroundColor: `#4c82bf`,
              }}
            >
              <Text style={{ color: 'white' }}>部門</Text>
            </PDFCell>
            <PDFCell
              flex={1}
              style={{
                backgroundColor: `#4c82bf`,
              }}
            >
              <Text style={{ color: 'white', textAlign: 'center' }}>各部門受測人數</Text>
            </PDFCell>
            <PDFCell
              flex={1}
              style={{
                backgroundColor: `#4c82bf`,
              }}
            >
              <Text style={{ color: 'white', textAlign: 'center' }}>各部門被釣中人數</Text>
            </PDFCell>
            <PDFCell
              flex={1}
              style={{
                backgroundColor: `#4c82bf`,
              }}
            >
              <Text style={{ color: 'white', textAlign: 'center' }}>瀏覽信件人數</Text>
            </PDFCell>
            <PDFCell
              flex={1}
              style={{
                backgroundColor: `#4c82bf`,
              }}
            >
              <Text style={{ color: 'white', textAlign: 'center' }}>點閱連結人數</Text>
            </PDFCell>
            <PDFCell
              flex={1}
              style={{
                backgroundColor: `#4c82bf`,
              }}
            >
              <Text style={{ color: 'white', textAlign: 'center' }}>開啟附件人數</Text>
            </PDFCell>
            <PDFCell
              flex={1}
              style={{
                backgroundColor: `#4c82bf`,
              }}
            >
              <Text style={{ color: 'white', textAlign: 'center' }}>輸入資料人數</Text>
            </PDFCell>
          </PDFRow>

          {/* <PDFRow>
    <PDFCell flex={1} style={{ backgroundColor: '#e8ecf2' }}>
      <Text>{1}</Text>
    </PDFCell>

    <PDFCell flex={2} style={{ backgroundColor: '#e8ecf2' }}>
      <Text>{123}</Text>
    </PDFCell>

    <PDFCell flex={1} style={{ backgroundColor: '#e8ecf2' }}>
      <Text>{123}</Text>
    </PDFCell>

    <PDFCell flex={1} style={{ backgroundColor: '#e8ecf2' }}>
      <Text>{123}</Text>
    </PDFCell>

    <PDFCell flex={1} style={{ backgroundColor: '#e8ecf2' }}>
      <Text>{123}</Text>
    </PDFCell>

    <PDFCell flex={1} style={{ backgroundColor: '#e8ecf2' }}>
      <Text>{123}</Text>
    </PDFCell>

    <PDFCell flex={1} style={{ backgroundColor: '#e8ecf2' }}>
      <Text>{123}</Text>
    </PDFCell>

    <PDFCell flex={1} style={{ backgroundColor: '#e8ecf2' }}>
      <Text>{123}</Text>
    </PDFCell>
  </PDFRow> */}

          {deptReportGroups?.map((group, index) => (
            <ReportRow key={`${index + 1}`} group={group} />
          ))}
        </View>
      </PDFPage>
    </>
  )
}

export default Chapter4Sub4Page
